<style>
div {
    margin-top: 20px;
    margin-left: 25px;
}
</style>

<script>
import Comment from './Comment.svelte'

export let comments;
</script>

{#if comments && comments.length != 0}
<div>
    {#each comments as commentId}
        <Comment {commentId}></Comment>
    {/each}
</div>
{/if}